<template>
  <div class="p-2">
    <div class="p-1">
      <div class="p-1">
        <div class="mb-1" style="font-weight: 300">NAME</div>
        <b-form-input class="search-input" v-model="medicalAlleyStartsQuery.account_name" @change="(e) => this.addQueryParam('account_name', e)" placeholder="Name"></b-form-input>
      </div>
      <div class="p-1">
        <div class="mb-1" style="font-weight: 300">ACCOUNT TYPE</div>
        <b-form-select :options="accountTypes" v-model="medicalAlleyStartsQuery.account_type" @change="(e) => this.addQueryParam('account_type', e)" />
      </div>
      <hr/>
      <div>
        <div class="d-flex align-items-center">
          <div style="font-weight: 300">ACTIVITIES / NOTES</div>
        </div>
        <div class="d-flex flex-wrap" v-if="queriedActivities.length > 0">
          <div class="m-1 p-1" style="font-size: 0.8em; color: #FFFFFF" v-for="activityQuery in queriedActivities" :key="activityQuery.id" :class="'comparator-' + activityQuery.comparator">
            <span style="font-weight: 300" v-if="activityQuery.comparator === 'IN'">DOES CONTAIN: </span>
            <span style="font-weight: 300" v-if="activityQuery.comparator === 'NOT'">DOES NOT CONTAIN: </span>
            {{ activityQuery.term }}
            <i class="fas fa-times ml-2" @click="removeActivitySearch(activityQuery.id)" style="cursor: pointer;"></i>
          </div>
        </div>
        <div>
          <b-form-select class="m-1" :options="booleanSearchOptions" v-model="activitySearchObject.comparator" />
          <b-form-input class="search-input m-1" v-model="activitySearchObject.term" placeholder="Text"></b-form-input>
          <div class="btn btn-sm btn-dark m-1" @click="addActivitySearchObject">ADD</div>
        </div>
      </div>
      <hr/>
      <div class="p-1">
        <div class="d-flex align-items-center">
          <div>ACCOUNT INFORMATION</div>
        </div>
        <div class="d-flex align-items-center py-2">
          <div class="pr-2" style="font-weight: 300">
            TAGS:
          </div>
          <b-form-select
            :options="accountTagOptions"
            v-model="medicalAlleyStartsQuery.account_has_tags"
            @change="(e) => this.addQueryParam('account_has_tags', e)"
          />
        </div>
        <div class="d-flex align-items-center py-2">
          <div class="pr-2" style="font-weight: 300">
            V3 Classification:
          </div>
          <b-form-select
            :options="accountV3ClassificationOptions"
            v-model="medicalAlleyStartsQuery.account_has_v3_classification"
            @change="(e) => this.addQueryParam('account_has_v3_classification', e)"
          />
        </div>
      </div>
      <hr/>
      <div class="p-1">
        <div class="d-flex align-items-center">
          <div>TAGS</div>
          <div class="ml-auto" @click="tagsToggled = !tagsToggled" style="cursor: pointer; font-size: 0.8em; font-weight: 300">{{ tagsToggled ? 'HIDE' : 'SHOW' }}</div>
        </div>
        <div class="p-1" v-if="tagsToggled">
          <div v-for="objectTag in objectTags" :key="objectTag.name">
            <div style="font-weight: 300">{{ objectTag.name }}</div>
            <div
              v-for="tag in objectTag.tags"
              :key="tag.id"
              class="my-1 p-1 tag"
              :class="isTagInQuery(tag.id) ? 'highlighted-tag':''"
              @click="isTagInQuery(tag.id) ? removeTagParam(tag.id) : addTagParam(tag.id)"
            >
              {{ tag.name }}
            </div>
          </div>
        </div>
      </div>
      <div style="height: 5vh;"></div>
    </div>
  </div>
</template>

<script>
import MedicalAlleyStartsMixin from './MedicalAlleyStartsMixin'
import store from '../../store'
export default {
  name: 'medical_alley_starts_sidebar',
  mixins: [MedicalAlleyStartsMixin],
  computed: {
    objectTags () {
      return [
        {
          'name': 'TYPE',
          'tags': this.tags.filter((x) => x.type === 'investor_tag')
        },
        {
          'name': 'TARGET AREA',
          'tags': this.tags.filter((x) => x.type === 'investor_target_area')
        },
        {
          'name': 'TARGET SIZE',
          'tags': this.tags.filter((x) => x.type === 'investor_target_size')
        }
      ]
    }
  },
  data: function () {
    return {
      //  All will represent filter types.
      accountTypes: [
        {
          text: 'All', value: null
        },
        {
          text: 'Organization', value: 'organization'
        },
        {
          text: 'Individual', value: 'individual'
        }
      ],
      tagsToggled: true,
      activitySearchObject: {},
      accountTagOptions: [
        {
          text: '', value: null
        },
        {
          text: 'HAS TAGS', value: true
        },
        {
          text: 'DOES NOT HAVE TAGS', value: false
        }
      ],
      accountDescriptionOptions: [
        {
          text: '', value: null
        },
        {
          text: 'HAS DESCRIPTION', value: true
        },
        {
          text: 'DOES NOT HAVE DESCRIPTION', value: false
        }
      ],
      accountV3ClassificationOptions: [
        {
          text: '', value: null
        },
        {
          text: 'HAS CLASSIFICATION FOR V3', value: true
        },
        {
          text: 'NOT CLASSIFIED FOR V3', value: false
        }
      ],
      booleanSearchOptions: [
        {
          text: 'DOES CONTAIN', value: 'IN'
        },
        {
          text: 'DOES NOT CONTAIN', value: 'NOT'
        }
      ]
    }
  },
  methods: {
    addActivitySearchObject () {
      this.addActivity(this.activitySearchObject)
      this.activitySearchObject = {}
    },
    submitSearch () {
      this.$emit('queryChanged')
    },
    removeActivitySearch (id) {
      for (let i = 0; i < this.queriedActivities.length; i++) {
        if (id === this.queriedActivities[i].id) {
          store.commit('removeActivityParam', i)
        }
      }
    }
  }
}
</script>

<style scoped>
.highlighted-tag {
  background: #be1e2d !important;
  color: #FFFFFF;
}
.tag {
  background: #EEEEEE;
  cursor: pointer;
}
.comparator-NOT {
  background:  #E68364;
  border: 1px solid #CF000F;
}
.comparator-IN {
  background:  #87D37C;
  border: 1px solid #5B8930;
}
.comparator-OR {
  background:  #F5D76E;
  border: 1px solid #FFB61E;
}
</style>



// WEBPACK FOOTER //
// src/components/medicalAlleyStarts/Sidebar.vue